export default __webpack_public_path__ + "static/media/CarPolishing.068e4a8b.webp";